// root getters

export default {
  menuNameList(state) {
    const menuList = []
    if (state.menuList && state.menuList.forEach) {
      state.menuList.forEach(value => {
        menuList.push(value.resourceUrl)
      })
    }
    return menuList
  },
  // 取到已经授权的菜单
  authorizedHistory(state) {
    const menuNameList = [] // 取得已授权的菜单
    if (state.menuList && state.menuList.forEach) {
      state.menuList.forEach(value => {
        menuNameList.push(value.resourceUrl)
      })
    }
    const menuHistory = []
    if (state.menuHistory && state.menuHistory.forEach) {
      state.menuHistory.forEach(value => {
        const index = menuNameList.indexOf(value.name)
        if (index !== -1) {
          menuHistory.push({
            name: value.name,
            time: value.time,
            resourceName: state.menuList[index].resourceName
          })
        }
      })
    }
    return menuHistory
  },
  isVideoManagementPage(state) {
    return state.currentResourcePath.includes('videoManagement')
  },
  getChildrenAccountInfo(state) {
    let rst = {}
    if (state.childrenAccount.currentChildrenAccount.cid === state.childrenAccount.currentChildrenAccount.proxyCid) {
      rst = {
        ...state.childrenAccount.currentChildrenAccount,
        portrait: localStorage.getItem('portrait')
      }
    } else {
      rst = state.childrenAccount.currentChildrenAccount
    }
    return rst
  }
}
